import React, { Component } from 'react';

import * as dateUtil from "../../util/dateUtil";

class DateInput extends Component {
    constructor(props) {
        super(props);

        this.controlDateTime = this.controlDateTime.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.value !== nextProps.value
        )
    }

    async controlDateTime(id, value) {
        const { onChange } = this.props;
        onChange(id, value);
    }

    render() {
        const { id, value, className, initDate } = this.props;
        const { controlDateTime } = this;

        return(
            <div className={'d-flex flex-column flex-md-row'}>
                <input
                    type="date"
                    className={className}
                    min={initDate}
                    value={value}
                    onChange={(e) => controlDateTime(id, e.target.value)}
                />
            </div>
        )
    }
}

DateInput.defaultProps = {
    id: "",
    value: dateUtil.dateToStr(new Date()),
    initDate: dateUtil.dateToStr(new Date()),
    className: "",
    onChange: function () {}
}

export default DateInput;
